/* ANYSNIFF — Webflow Interactions (IX2) reimplemented in GSAP
 *
 * The Webflow site drove six live interactions through its IX2 runtime, with the
 * definitions compiled into the site's own JS bundle. They are ported here 1:1
 * (same targets, values, units, durations, easings, stagger) so the theme needs
 * no Webflow runtime. The source spec is in docs/IX2-SPEC.md.
 *
 * Webflow easing -> GSAP:  outQuad power1.out | inQuad power1.in
 *                          inOutQuad power1.inOut | outQuart power4.out
 * Webflow "scroll into view, 25% offset" -> ScrollTrigger start 'top 75%'.
 */
(function () {
  'use strict';
  if (!window.gsap) return;
  if (window.ScrollTrigger) gsap.registerPlugin(ScrollTrigger);

  var $ = function (s) { return document.querySelector(s); };
  var $$ = function (s) { return Array.prototype.slice.call(document.querySelectorAll(s)); };

  /* Keep ScrollTrigger in step with Lenis' smoothed scroll position.
   * The site's own connectToScrollTrigger() is dead code (defined, never called) and
   * is left that way — calling it would add a second RAF loop driving Lenis. This is
   * only the update hook, which is the half that was actually needed. */
  if (window.lenis && window.ScrollTrigger) {
    window.lenis.on('scroll', ScrollTrigger.update);
  }

  /* ---------- a-7 · PAGE_FINISH: loader + hero circle (home) ---------- */
  var loader = $('.loader');
  // Kolo jest tylko na stronie glownej. Bez tego warunku GSAP dostawal selektor
  // bez trafien na kazdej innej stronie: wypisywal ostrzezenie do konsoli i
  // trzymal loader w DOM przez pelne 5 s zamiast 2,75 s, bo pusty tween i tak
  // liczy sie do dlugosci osi czasu.
  var maKolo = !!$('.hero_circle');
  if (loader) {
    gsap.set('.loader_progress', { width: '0%' });
    gsap.set(loader, { yPercent: 0 });
    if (maKolo) gsap.set('.hero_circle', { rotate: 90, scale: 0.8 });

    var tl = gsap.timeline()
      .to('.loader_progress', { width: '100%', duration: 2, ease: 'power1.inOut' })
      .addLabel('out')
      .to(loader, { yPercent: -100, duration: 0.75, ease: 'power1.in' }, 'out');
    if (maKolo) {
      tl.to('.hero_circle', { rotate: 0, duration: 3, ease: 'power1.out' }, 'out')
        .to('.hero_circle', { scale: 1, duration: 2, ease: 'power1.out' }, 'out');
    }
    tl.set(loader, { display: 'none' });
  } else if (maKolo) {
    // Pages without a loader still need the hero circle at rest.
    gsap.set('.hero_circle', { rotate: 0, scale: 1 });
  }

  /* ---------- a · PAGE_FINISH (looping): CTA text carousel ---------- */
  if ($('.cta_text-inner')) {
    var TXT = '.cta_text-inner',
        LFT = '.cta_bracket-wrap.is-left',
        RGT = '.cta_bracket-wrap.is-right';
    var cta = gsap.timeline({ repeat: -1 });
    cta.set(TXT, { y: '0em' }).set(LFT, { x: '0.5em' }).set(RGT, { x: '-0.5em' });

    // Pozycja '<' oznacza start POPRZEDNIEJ animacji, a nie poprzedniej grupy.
    // Przy '<' na wszystkich trzech tweenach kazdy wjezdzal na start tego przed
    // nim i dostawal wlasne delay: 1, wiec tekst i obie litery ruszaly osobno,
    // w sekundowych odstepach, zamiast razem. Petla puchla do 9,5 s.
    //
    // Teraz pauze 1 s niesie pozycja '+=1' na tweenie tekstu (czyli sekunda po
    // koncu timeline'u), a litery wchodza na '<', czyli w tej samej chwili co on.
    [[-5, -2, 2], [-10, -1, 1], [-15, 0.5, -0.5]].forEach(function (s) {
      cta.to(TXT, { y: s[0] + 'em', duration: 0.5, ease: 'power1.out' }, '+=1')
         .to(LFT, { x: s[1] + 'em', duration: 0.5, ease: 'power1.out' }, '<')
         .to(RGT, { x: s[2] + 'em', duration: 0.5, ease: 'power1.out' }, '<');
    });
    // Powrot do stanu poczatkowego dopiero SEKUNDE po ostatnim kroku — inaczej
    // czwarte slowo (powtorzone „anytime") nie zdazyloby sie pokazac.
    // Litery wracaja niewidocznie, bo ostatni krok (+-0.5em) to juz ich pozycja
    // startowa; przeskakuje wylacznie tekst, i to o dokladnie cztery wiersze.
    cta.set(TXT, { y: '0em' }, '+=1').set(LFT, { x: '0.5em' }).set(RGT, { x: '-0.5em' });
  }

  /* ---------- a-2 · SCROLL_INTO_VIEW .features_bottom (25%) ---------- */
  $$('.features_bottom').forEach(function (wrap) {
    var items = wrap.querySelectorAll('.features_item');
    if (!items.length) return;
    gsap.set(items, { y: '3rem', opacity: 0 });
    ScrollTrigger.create({
      trigger: wrap, start: 'top 75%', once: true,
      onEnter: function () {
        gsap.to(items, { y: '0rem', opacity: 1, duration: 0.5, ease: 'power1.out', stagger: 0.2 });
      }
    });
  });

  /* ---------- a-5 · SCROLL_INTO_VIEW .steps_step (25%) ---------- */
  $$('.steps_step').forEach(function (el) {
    gsap.set(el, { y: '3rem', opacity: 0 });
    ScrollTrigger.create({
      trigger: el, start: 'top 75%', once: true,
      onEnter: function () {
        gsap.to(el, { y: '0rem', opacity: 1, duration: 0.5, ease: 'power1.out' });
      }
    });
  });

  /* ---------- a-3 / a-4 · footer logo in and out of view ---------- */
  var fWrap = $('.footer_logo-wrapper');
  if (fWrap) {
    var fInner = fWrap.querySelector('.footer_logo-inner');
    if (fInner) {
      gsap.set(fInner, { yPercent: 100 });
      var up = function () { gsap.to(fInner, { yPercent: 0, duration: 0.5, ease: 'power1.out' }); };
      var down = function () { gsap.to(fInner, { yPercent: 100, duration: 0.5, ease: 'power1.in' }); };
      ScrollTrigger.create({
        trigger: fWrap, start: 'top bottom', end: 'bottom top',
        onEnter: up, onEnterBack: up, onLeave: down, onLeaveBack: down
      });
    }
  }

  /* ---------- a-10 · SCROLLING_IN_VIEW .image-move (parallax) ---------- */
  $$('.image-move').forEach(function (el) {
    gsap.fromTo(el, { yPercent: -10 }, {
      yPercent: 0, ease: 'none',
      scrollTrigger: { trigger: el, start: 'top bottom', end: 'bottom top', scrub: true }
    });
  });

  /* Not ported, deliberately — dead on every current page:
   *   a-6  (.trigger click -> loader dismiss): no .trigger / .loader_bottom in the DOM
   *   a-8 / a-9 (.button hover): targets a .button_text child that no page renders,
   *                              and the interaction does not fire on the live site.
   */
})();
